import React, { useRef } from 'react';
import { CrmInput } from '../ui';
import LocationStateCityFields from './LocationStateCityFields';
import { normalizeAddress } from './settingsFormUtils';

export default function AddressFields({ label, value, onChange }) {
  const address = normalizeAddress(value);
  const addressRef = useRef(address);

  // Keep latest rendered address, while preserving sequential updates
  // triggered inside the same change event.
  addressRef.current = address;

  const set = (key, nextValue) => {
    const nextAddress = {
      ...addressRef.current,
      [key]: nextValue,
    };

    addressRef.current = nextAddress;
    onChange?.(nextAddress);
  };

  return (
    <fieldset className="settings-address settings-form-grid__wide">
      <legend>{label}</legend>

      <div className="settings-form-grid">
        <CrmInput
          className="settings-form-grid__wide"
          label="Address line 1"
          value={address.line1}
          onChange={(event) => set('line1', event.target.value)}
        />

        <CrmInput
          className="settings-form-grid__wide"
          label="Address line 2"
          value={address.line2}
          onChange={(event) => set('line2', event.target.value)}
        />

        <LocationStateCityFields
          country={address.country}
          state={address.state}
          city={address.city}
          onChange={set}
        />

        <CrmInput
          label="Postal code"
          value={address.pincode}
          onChange={(event) => set('pincode', event.target.value)}
        />
      </div>
    </fieldset>
  );
}